import * as React from 'react';
import { Spinner } from './spinner';

interface PageLoaderProps {
  label?: string;
}

export const PageLoader: React.FC<PageLoaderProps> = ({ label }) => (
  <div className="p-8 flex flex-col items-center justify-center gap-3 text-muted-foreground">
    <Spinner size="xl" />
    {label && <p className="text-sm">{label}</p>}
  </div>
);
